import { useLocation } from 'react-router-dom';
import useCustomNavigation from '../../../common/hooks/useCustomNavigation';
import useUserContext from '../../../common/hooks/useUserContext';
import CheckIntegrationSetting from '../../../utils/integrationHelper';
import { IntegrationMode } from '../../../utils/IntegrationConstants';
import useIntegrationContext from '../../../common/hooks/useIntegrationContext';

const SecurityQuestions = () => {
  const { user } = useUserContext();
  const navigate = useCustomNavigation();
  const location = useLocation();
  const { integrationContext } = useIntegrationContext();

  if (
    location.pathname !== '/' &&
    !location.pathname.startsWith('/c/') &&
    user.mustAnswerSecurityQuestions
  ) {
    if (!CheckIntegrationSetting(IntegrationMode.Teams, integrationContext.mode)) {
      navigate(
        '/c/usersecurityquestion?relyingParty=ELIXHRUI&nodeKey=self_questions&nodeUrl=/usersecurityquestion&im=1'
      );
    } else {
      navigate(
        '/c/usersecurityquestion?relyingParty=ELIXHRUI&nodeKey=self_questions&nodeUrl=/usersecurityquestion'
      );
    }
  }
  return null;
};

export default SecurityQuestions;
